module.exports = __webpack_public_path__ + "img/yips1.42890d46.png";